/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Zone from 'astro/server/zone';

import * as Influence from 'astro/util/influence';


export default class extends Zone
{
  constructor (cass, planet)
  {
    super(cass, planet);
  }


  install ()
  {
    if (this.getAttributes().getPlatformSource())
    {
      const target = this.planet.getZones().getOne(this.getAttributes().getPlatformSource().id);

      target.getAttributes().installInfluence(this.makePlatformInfluence());
    }
  }



  makePlatformInfluence ()
  {
    const user = this.getCass().getUser();

    return Influence.makePlatform(user, this.getLocation(), this.getAttributes().getInfluence(user));
  }


  isLocal ()
  {
    return true;
  }


  isPlatform ()
  {
    return true;
  }


};
